import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import {Section, SectionBgWrap, SectionLead, SectionTitle,Container} from '../components/Section'
import SecondButton from '../components/Button/SecondButton';
import PhoneIcon from '../components/Icons/PhoneIcon';

const BgWrap = styled(SectionBgWrap)`
	width: 100%;
	height: 100%;
	overflow: hidden;
	.gatsby-image-wrapper {
		width: 100%;
	}
`
const CtaGrid = styled.div`
	display:flex;
	flex-wrap:wrap;
	align-items:center;
	justify-content:center;
	margin:0 -15px;
	@media (min-width:992px){
		margin:0 -30px;
	}
`
const CtaLeftGrid = styled.div`
	position:relative;
	width:100%;
	padding:0 15px;
	@media (min-width:768px){
		flex: 0 0 auto;
        width: auto;
        max-width: 100%;
	}
	@media (min-width:992px){
		padding:0 30px;
	}
	h2{
		@media (min-width:768px){
			margin-bottom:0;	
		}
	}

`
const CtaRightGrid = styled.div`
	position:relative;
	width:100%;
	padding:0 15px;
	@media (min-width:768px){
		flex: 0 0 auto;
        width: auto;
        max-width: 100%;
	}
	@media (min-width:992px){
		padding:0 30px;
	}
`


const CtaSection = () => (
	<Section ept="120px" epb="120px" xpt="100px" xpb="100px" lpt="80px" lpb="80px" pt="40px" pb="40px">
		<BgWrap><StaticImage src="../images/cta-bg.png" placeholder="blurred" quality={95} formats={["AUTO", "WEBP", "AVIF"]} alt="About"/></BgWrap>
		<Container>
			<CtaGrid>
				<CtaLeftGrid>
					<SectionLead color="#fff" mb="0" textAlign="left">Get your dream building installed at your site</SectionLead>
					<SectionTitle color="#fff" textAlign="left">Call today to talk to our building experts</SectionTitle>
				</CtaLeftGrid>
				<CtaRightGrid>
					<a href="tel:3867556449" aria-label='contact-number'><SecondButton size="lg" text="(386) 755-6449" preIcon={<PhoneIcon fill="#ffffff" />} /></a>
				</CtaRightGrid>
			</CtaGrid>
		</Container>
	</Section>
);

export default CtaSection;